/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DashboardPageBlockTableComparisonRow = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The DashboardPageBlockTableComparisonRow model module.
   * @module model/DashboardPageBlockTableComparisonRow
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DashboardPageBlockTableComparisonRow</code>.
   * @alias module:model/DashboardPageBlockTableComparisonRow
   * @class
   */
  var exports = function() {
    var _this = this;
















  };

  /**
   * Constructs a <code>DashboardPageBlockTableComparisonRow</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DashboardPageBlockTableComparisonRow} obj Optional instance to populate.
   * @return {module:model/DashboardPageBlockTableComparisonRow} The populated <code>DashboardPageBlockTableComparisonRow</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('FromRowID')) {
        obj['FromRowID'] = ApiClient.convertToType(data['FromRowID'], 'Integer');
      }
      if (data.hasOwnProperty('ToRowID')) {
        obj['ToRowID'] = ApiClient.convertToType(data['ToRowID'], 'Integer');
      }
      if (data.hasOwnProperty('ComparisonCalculationID')) {
        obj['ComparisonCalculationID'] = ApiClient.convertToType(data['ComparisonCalculationID'], 'Integer');
      }
      if (data.hasOwnProperty('BackgroundColor')) {
        obj['BackgroundColor'] = ApiClient.convertToType(data['BackgroundColor'], 'String');
      }
      if (data.hasOwnProperty('BordersVisible')) {
        obj['BordersVisible'] = ApiClient.convertToType(data['BordersVisible'], 'Boolean');
      }
      if (data.hasOwnProperty('IsBold')) {
        obj['IsBold'] = ApiClient.convertToType(data['IsBold'], 'Boolean');
      }
      if (data.hasOwnProperty('HighlightNegative')) {
        obj['HighlightNegative'] = ApiClient.convertToType(data['HighlightNegative'], 'Boolean');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('IsSummedRow')) {
        obj['IsSummedRow'] = ApiClient.convertToType(data['IsSummedRow'], 'Boolean');
      }
      if (data.hasOwnProperty('FromSumRowID')) {
        obj['FromSumRowID'] = ApiClient.convertToType(data['FromSumRowID'], 'Integer');
      }
      if (data.hasOwnProperty('ToSumRowID')) {
        obj['ToSumRowID'] = ApiClient.convertToType(data['ToSumRowID'], 'Integer');
      }
      if (data.hasOwnProperty('Hidden')) {
        obj['Hidden'] = ApiClient.convertToType(data['Hidden'], 'Boolean');
      }
      if (data.hasOwnProperty('BlockID')) {
        obj['BlockID'] = ApiClient.convertToType(data['BlockID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} FromRowID
   */
  exports.prototype['FromRowID'] = undefined;
  /**
   * @member {Integer} ToRowID
   */
  exports.prototype['ToRowID'] = undefined;
  /**
   * @member {Integer} ComparisonCalculationID
   */
  exports.prototype['ComparisonCalculationID'] = undefined;
  /**
   * @member {String} BackgroundColor
   * @default ''
   */
  exports.prototype['BackgroundColor'] = '';
  /**
   * @member {Boolean} BordersVisible
   * @default false
   */
  exports.prototype['BordersVisible'] = false;
  /**
   * @member {Boolean} IsBold
   * @default false
   */
  exports.prototype['IsBold'] = false;
  /**
   * @member {Boolean} HighlightNegative
   * @default false
   */
  exports.prototype['HighlightNegative'] = false;
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Boolean} IsSummedRow
   * @default false
   */
  exports.prototype['IsSummedRow'] = false;
  /**
   * @member {Integer} FromSumRowID
   */
  exports.prototype['FromSumRowID'] = undefined;
  /**
   * @member {Integer} ToSumRowID
   */
  exports.prototype['ToSumRowID'] = undefined;
  /**
   * @member {Boolean} Hidden
   * @default false
   */
  exports.prototype['Hidden'] = false;
  /**
   * @member {Integer} BlockID
   * @default 0
   */
  exports.prototype['BlockID'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


